"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginButtonSmall = exports.LoginButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Link = _interopRequireDefault(require("@material-ui/core/Link"));

var _AccountCircle = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Home = _interopRequireDefault(require("@material-ui/icons/Home"));

var _reactRouterDom = require("react-router-dom");

var _utilities = require("../utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    loginLink: {
      color: 'inherit',
      "&:hover": {
        color: 'inherit'
      }
    }
  };
});
var StyledButton = (0, _core.withStyles)(function (theme) {
  return {
    root: {
      textTransform: 'none',
      color: "inherit",
      borderColor: "currentColor"
    }
  };
})(_Button.default);
var StyledIconButton = (0, _core.withStyles)(function (theme) {
  return {
    root: {
      textTransform: 'none'
    }
  };
})(_IconButton.default);

var LoginButton = function LoginButton(props) {
  var loginButtonFactory = function loginButtonFactory(props, handleClickBar) {
    return /*#__PURE__*/_react.default.createElement(LogguedInButton, _extends({}, props, {
      handleClickBar: handleClickBar
    }));
  };

  var menuFactory = function menuFactory(props, anchor, handleCloseBar) {
    return /*#__PURE__*/_react.default.createElement(LoginMenu, _extends({}, props, {
      anchor: anchor,
      handleCloseBar: handleCloseBar
    }));
  };

  return /*#__PURE__*/_react.default.createElement(AbstractLoginButton, _extends({}, props, {
    loginButtonFactory: loginButtonFactory,
    menuFactory: menuFactory
  }));
};

exports.LoginButton = LoginButton;

var LoginButtonSmall = function LoginButtonSmall(props) {
  var loginButtonFactory = function loginButtonFactory(props, handleClickBar) {
    return /*#__PURE__*/_react.default.createElement(LogguedInButtonSmall, _extends({}, props, {
      handleClickBar: handleClickBar
    }));
  };

  var menuFactory = function menuFactory(props, anchor, handleCloseBar) {
    return /*#__PURE__*/_react.default.createElement(LoginMenuSmall, _extends({}, props, {
      anchor: anchor,
      handleCloseBar: handleCloseBar
    }));
  };

  return /*#__PURE__*/_react.default.createElement(AbstractLoginButton, _extends({}, props, {
    loginButtonFactory: loginButtonFactory,
    menuFactory: menuFactory
  }));
};

exports.LoginButtonSmall = LoginButtonSmall;

var AbstractLoginButton = function AbstractLoginButton(props) {
  var token = props.token,
      loginButtonFactory = props.loginButtonFactory,
      menuFactory = props.menuFactory;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchor = _useState2[0],
      setAnchor = _useState2[1];

  var handleClickBar = function handleClickBar(event) {
    setAnchor(event.currentTarget);
  };

  var handleCloseBar = function handleCloseBar() {
    setAnchor(null);
  };

  var loginButton = token ? loginButtonFactory(props, handleClickBar) : /*#__PURE__*/_react.default.createElement(NotLogguedInButton, null);
  var menu = menuFactory(props, anchor, handleCloseBar);
  return /*#__PURE__*/_react.default.createElement(LoginButtonWrapper, _extends({}, props, {
    menu: menu
  }), loginButton);
};

var LoginButtonWrapper = function LoginButtonWrapper(props) {
  var classes = useStyles();
  var menu = props.menu,
      token = props.token,
      children = props.children;
  return token ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children, menu) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/login",
    className: classes.loginLink
  }, children);
};

var LogguedInButton = function LogguedInButton(_ref) {
  var userInfo = _ref.userInfo,
      handleClickBar = _ref.handleClickBar;
  return /*#__PURE__*/_react.default.createElement(StyledButton, {
    variant: "outlined",
    startIcon: /*#__PURE__*/_react.default.createElement(_AccountCircle.default, {
      htmlColor: "#FFFFFF"
    }),
    endIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
    onClick: handleClickBar
  }, userInfo && userInfo.username);
};

var LogguedInButtonSmall = function LogguedInButtonSmall(_ref2) {
  var userInfo = _ref2.userInfo,
      handleClickBar = _ref2.handleClickBar;
  return /*#__PURE__*/_react.default.createElement(StyledIconButton, {
    variant: "outlined",
    color: "inherit",
    onClick: handleClickBar
  }, /*#__PURE__*/_react.default.createElement(_Home.default, {
    color: "inherit"
  }));
};

var NotLogguedInButton = function NotLogguedInButton() {
  return /*#__PURE__*/_react.default.createElement(StyledButton, {
    variant: "outlined"
  }, "Login");
};

var LoginMenu = function LoginMenu(props) {
  var anchor = props.anchor,
      handleCloseBar = props.handleCloseBar,
      handleLogout = props.handleLogout;
  return /*#__PURE__*/_react.default.createElement(_Menu.default, {
    anchorEl: anchor,
    keepMounted: true,
    open: Boolean(anchor),
    onClose: handleCloseBar,
    elevation: 0,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: handleLogout
  }, "Logout"));
};

var LoginMenuSmall = function LoginMenuSmall(props) {
  var token = props.token,
      availableLinksEntries = props.availableLinksEntries,
      anchor = props.anchor,
      handleCloseBar = props.handleCloseBar,
      handleLogout = props.handleLogout;
  return /*#__PURE__*/_react.default.createElement(_Menu.default, {
    anchorEl: anchor,
    keepMounted: true,
    open: Boolean(anchor),
    onClose: handleCloseBar,
    elevation: 0,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, availableLinksEntries.map(function (item, key) {
    var url = (0, _utilities.buildFromRedirectLink)(item[1], token);
    var underlined = (0, _utilities.isBaseUrlMatchService)(item[1]) ? 'always' : 'none';
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: key
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      style: {
        width: '100%'
      },
      href: url,
      color: "inherit",
      underline: underlined
    }, item[0]));
  }), /*#__PURE__*/_react.default.createElement(_MenuItem.default, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
    style: {
      width: '100%'
    },
    onClick: handleLogout,
    color: "inherit"
  }, "Logout")));
};